<template>
  <div
    id="list-vacancy"
    class="w-100"
  >
    <div class="container">
      <header
        v-if="totalRecords > 0"
        class="section-header"
      >
        <div class="skeleton-loading">
          <div
            v-if="vacLoading"
            class="w-50 py-4 mx-auto d-block"
          >
            <div
              class="text-skeleton"
              style="height: 35px"
            />
          </div>
        </div>

        <h2
          v-if="!vacLoading && vacancies.vacancy != undefined"
          class="text-color-fifth"
        >
          {{ totalRecords }} {{ wordVacancy }} {{ wordOpen }}
        </h2>
      </header>

      <div
        v-if="!vacLoading && totalRecords <= 0"
        class="not-result result p-5 animated bounceIn"
      >
        <h3
          class="text-center font-weight"
          :style="{'color': `${currentScopedCompanyPage.primary_color}` + ' !important'}"
        >
          Ooops!
        </h3>
        <p
          class="text-center"
          :style="{'color': `${currentScopedCompanyPage.primary_color}` + ' !important'}"
        >
          Essa empresa não possui processos seletivos abertos ou não encontramos vagas para sua pesquisa,
          <br>
          tente outra palavra-chave.
        </p>
      </div>

      <!-- START: VERSION DESKTOP -->
      <table class="table border-0 d-none d-md-none d-lg-block">
        <thead v-if="totalRecords > 0">
          <tr>
            <!-- w-10 -->
            <th
              v-if="validateSubdomain"
              scope="col"
            />
            <!-- w-25 -->
            <th
              class="font-weight-bold text-color-secondary"
              scope="col"
              :style="{'color': `${currentScopedCompanyPage.primary_color}` + ' !important'}"
            >
              Cargo
            </th>
            <!-- w-20 -->
            <th
              class="font-weight-bold text-color-secondary"
              scope="col"
              :style="{'color': `${currentScopedCompanyPage.primary_color}` + ' !important'}"
            >
              Publicada em
            </th>
            <!-- w-11 -->
            <th
              class="font-weight-bold text-color-secondary"
              scope="col"
              :style="{'color': `${currentScopedCompanyPage.primary_color}` + ' !important'}"
            >
              Nível
            </th>
            <!-- w-15 -->
            <th
              class="font-weight-bold text-color-secondary"
              scope="col"
              :style="{'color': `${currentScopedCompanyPage.primary_color}` + ' !important'}"
            >
              Tipo de contrato
            </th>
            <!-- w-10 -->
            <th
              class="font-weight-bold text-color-secondary"
              scope="col"
              :style="{'color': `${currentScopedCompanyPage.primary_color}` + ' !important'}"
            >
              Localização
            </th>
            <!-- w-10 -->
            <th scope="col" />
          </tr>
        </thead>
        <!-- START: SKELETON LOADING -->
        <tbody v-if="vacLoading">
          <tr
            v-for="(loading, index) in loadings"
            :key="index"
            class="skeleton-loading"
          >
            <td
              v-if="validateSubdomain"
              class="w-5 py-4 align-middle"
              style="min-width: 64px;"
            >
              <div
                alt="Avatar"
                class="avatar mr-2"
              />
            </td>
            <td class="w-25 py-4 align-middle">
              <div class="text-skeleton" />
            </td>
            <td class="w-25 py-4 align-middle">
              <div class="text-skeleton" />
            </td>
            <td class="w-25 py-4 align-middle">
              <div class="text-skeleton" />
            </td>
            <td class="w-25 py-4 align-middle">
              <div class="text-skeleton" />
            </td>
            <td class="w-25 py-4 align-middle">
              <div class="text-skeleton" />
            </td>
            <td class="w-25 py-4 align-middle">
              <a
                class="btn btn-round bg-color-primary text-white pull-right btn-skeleton"
                style="background-color: #ddd !important"
              />
            </td>
          </tr>
        </tbody>
        <!-- END: SKELETON LOADING -->

        <!-- START: LIST VACANCIES -->
        <tbody v-if="!vacLoading && vacancies.vacancy != undefined">
          <tr
            v-for="(vacancy, index) in Object.values(vacancies.vacancy).reverse()"
            :key="index"
          >
            <!-- Image Company [visible only list all vacancies] -->
            <td
              v-if="validateSubdomain"
              style="min-width: 64px;"
              class="py-4 align-middle"
            >
              <a
                v-if="!vacancies.company[vacancy.relationships.company.data.id].attributes.manageOther && !vacancy.attributes.promoteCompany"
                :href="vacancy.links.companyUrl"
              >
                <img
                  v-tippy="{placement : 'top', arrow: true, arrowType: 'round', theme: 'google'}"
                  src="../assets/landings/avatar/iconic_confidential.jpg"
                  alt="Avatar"
                  class="avatar mr-2"
                  content="Empresa confidencial"
                >
              </a>
              <a
                v-else
                :href="vacancy.links.companyUrl"
              >
                <img
                  v-tippy="{placement : 'top', arrow: true, arrowType: 'round', theme: 'google'}"
                  :content="vacancies.company[vacancy.relationships.company.data.id].attributes.name"
                  :src="getAvatar"
                  alt="Avatar"
                  class="avatar mr-2"
                >
              </a>
            </td>

            <!-- Name vacancy -->
            <td class="py-4 align-middle">
              <a :href="vacancy.links.vacancyUrl">
                <strong>
                  <span v-if="vacancy.attributes.exclusivePcd">
                    <img
                      src="../assets/landings/icon/icon-pcd.svg"
                      class="pcd-logo"
                      alt="pcd logo"
                    >
                  </span>
                  {{ vacancy.id }} - {{ vacancy.attributes.title }}
                </strong>
              </a>
            </td>

            <!-- create at -->
            <td class="py-4 align-middle">
              {{ vacancy.attributes.republishedAt }}
            </td>

            <!-- Level of interest vacancy -->
            <td class="py-4 align-middle">
              <template v-if="vacancy.relationships.levelOfInterest.data !== null">
                {{ vacancies.levelOfInterest[vacancy.relationships.levelOfInterest.data.id].attributes.name }}
              </template>
              <template v-else>
                Não informado
              </template>
            </td>

            <!-- Contracting regime -->
            <td class="py-4 align-middle">
              <template v-if="!_.isObject(vacancy.attributes.contractingRegime)">
                {{ vacancy.attributes.contractingRegime }}
              </template>
              <template v-else>
                Não informado
              </template>
            </td>

            <!-- Location vacancy -->
            <td class="py- align-middle w-20">
              {{ vacancy.attributes.location }}
            </td>

            <td class="py-4 w-5 align-middle apply-for">
              <!-- start: button apply for vacancy -->
              <b-link
                v-if="!vacancy.meta.candidature"
                :id="'apply-' + vacancy.id"
                :href="vacancy.links.vacancyUrl"
                class="btn btn-round bg-color-primary btn-apply text-white pull-right"
                :style="{'background-color': `${currentScopedCompanyPage.secondary_color}` + ' !important',}"
              >
                Candidatar
              </b-link>
              <!-- end: button apply for vacancy -->

              <!-- start: button applied for the vacancy -->
              <b-link
                v-if="vacancy.meta.candidature"
                :id="'applied-' + vacancy.id"
                :href="vacancy.links.vacancyUrl"
                class="btn btn-round bg-color-primary btn-applied text-white pull-right"
                :style="{'background-color': `${currentScopedCompanyPage.primary_color}` + ' !important'}"
              >
                Candidatado
              </b-link>
              <!-- end: button applied for the vacancy -->
            </td>
          </tr>
        </tbody>
        <!-- END: LIST VACANCIES -->
      </table>
      <!-- END: VERSION DESKTOP -->

      <!-- START: VERSION MOBILE -->
      <!-- START: SKELETON LOADING -->
      <div
        v-if="vacLoading"
        class="row vacancies-list-cards d-block-md d-lg-none"
      >
        <div
          v-for="(loading, index) in loadings"
          :key="index"
          class="col-12 col-sm-6"
        >
          <div
            style="width: 18rem;"
            class="card w-100 mb-6"
          >
            <div class="card-body skeleton-loading">
              <div
                class="text-skeleton w-75 mx-auto d-block"
                style="height: 22px"
              />
              <div
                class="text-skeleton w-25 mx-auto d-block my-2 mb-5"
                style="height: 16px"
              />

              <div
                class="text-skeleton w-50 mx-auto d-block my-2"
                style="height: 13px"
              />
              <div
                class="text-skeleton w-50 mx-auto d-block my-2"
                style="height: 13px"
              />
              <div
                class="text-skeleton w-50 mx-auto d-block my-2 mb-5"
                style="height: 13px"
              />

              <button
                class="btn btn-round text-white w-100"
                style="width: 140px; height: 36px; background-color: #ccc; "
              />
            </div>
          </div>
        </div>
      </div>
      <!-- END: SKELETON LOADING -->

      <!-- START: LIST VACANCIES -->
      <div
        v-if="!vacLoading && vacancies.vacancy != undefined"
        class="row vacancies-list-cards d-block-md d-lg-none"
      >
        <div
          v-for="(vacancy, index) in Object.values(vacancies.vacancy).reverse()"
          :key="index"
          class="col-12 col-sm-6"
        >
          <div
            class="card w-100 mb-6"
            style="width: 18rem;"
          >
            <div class="card-body">
              <h4
                class="text-center card-title font-weight-bold mb-1 text-color-secondary"
                :style="{'color': `${currentScopedCompanyPage.primary_color}` + ' !important'}"
              >
                <a
                  class="text-color-secondary"
                  :href="vacancy.links.vacancyUrl"
                  :style="{'color': `${currentScopedCompanyPage.primary_color}` + ' !important'}"
                >
                  {{ vacancy.id }} - {{ vacancy.attributes.title }}
                </a>
              </h4>
              <h6 class="text-center card-subtitle mb-4 text-muted">
                <strong
                  v-if="!vacancies.company[vacancy.relationships.company.data.id].attributes.manageOther && !vacancy.attributes.promoteCompany"
                  class="font-weight-bold"
                >
                  Empresa confidencial
                </strong>
                <!-- <strong
                  v-else
                  class="font-weight-bold"
                >
                {{ setVacancyOwner(vacancy) }}
                </strong> -->
              </h6>

              <p class="text-center card-text">
                <!-- Level of interest vacancy -->
                <strong>Nível:</strong>
                <template v-if="vacancy.relationships.levelOfInterest.data !== null">
                  {{ vacancies.levelOfInterest[vacancy.relationships.levelOfInterest.data.id].attributes.name }}
                </template>
                <template v-else>
                  Não informado
                </template>
                <br>

                <!-- Contracting regime -->
                <strong>Contrato:</strong>
                <template v-if="!_.isObject(vacancy.attributes.contractingRegime)">
                  {{ vacancy.attributes.contractingRegime }}
                </template>
                <template v-else>
                  Não informado
                </template>
                <br>

                <strong>Localização:</strong>
                {{ vacancy.attributes.location }}
                <br>

                <span>
                  <strong>Exclusivo PCD:</strong>
                  {{ vacancy.attributes.exclusivePcd ? 'Sim':'Não' }}
                  <br>
                </span>
              </p>

              <div>
                <!-- start: button apply for vacancy -->
                <b-link
                  v-if="!vacancy.meta.candidature"
                  :id="'apply-' + vacancy.id"
                  :href="vacancy.links.vacancyUrl"
                  class="btn btn-round bg-color-primary text-white pull-right w-100"
                  :style="{'background-color': `${currentScopedCompanyPage.secondary_color}` + ' !important'}"
                >
                  Candidatar
                </b-link>
                <!-- end: button apply for vacancy -->

                <!-- start: button applied for the vacancy -->
                <b-link
                  v-if="vacancy.meta.candidature"
                  :id="'applied-' + vacancy.id"
                  :href="vacancy.links.vacancyUrl"
                  class="btn btn-round bg-color-primary text-white pull-right w-100"
                  :style="{'background-color': `${currentScopedCompanyPage.primary_color}` + ' !important'}"
                >
                  Candidatado
                </b-link>
                <!-- end: button applied for the vacancy -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END: LIST VACANCIES -->
      <!-- END: VERSION MOBILE -->

      <!-- Button Visible Landing Page -->
      <div
        v-if="validateSubdomain"
        class="text-center"
      >
        <a
          href="./vagas"
          class="btn btn-round bg-color-primary btn-lg text-white text-center mt-4"
        >
          VER TODAS AS VAGAS
        </a>
      </div>

      <!-- Pagination visible page vacancy -->
      <b-pagination
        v-if="totalRecords > 0"
        v-model="currentPage"
        size="md"
        :total-rows="Number(totalRecords)"
        :per-page="15"
        align="center"
        class="mt-5"
        active-class="teste"
        @input="updatePage(currentPage)"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import mixins from '../mixins/mixins';

export default {
  name: 'ListVacancy',
  mixins: [mixins],
  data() {
    return {
      wordVacancy: '',
      wordOpen: '',
      loadings: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    };
  },
  computed: {
    ...mapState('UserStore', [
      'currentUser',
    ]),
    ...mapState('CompanyStore', [
      'currentScopedCompany',
      'currentScopedCompanyPage',
    ]),
    ...mapState('VacancyStore', [
      'vacancies',
      'vacLoading',
      'pagination',
      'totalRecords',
      'wordSearch',
      'citySearch',
      'levelSearch',
      'contractingSearch',
      'fitCandidateSearch',
      'currentPageV',
    ]),
    ...mapGetters('UserStore', [
      'currentUserIsAdmin',
      'currentUserIsCompanyUser',
      'userIsLoggedIn',
    ]),
    ...mapGetters('CompanyStore', [
      'currentScopedCompanyManagerOther',
    ]),
    getAvatar() {
      if (!this.vacancies) {
        return;
      }

      const key = Object.keys(this.vacancies.companyPage)[0]
      return this.vacancies.companyPage[key].attributes.avatar;
    },
  },
  async mounted() {
    await this.$store.dispatch('VacancyStore/loadVacancies');

    this.$store.subscribe((mutation) => {
      if (mutation.type === 'VacancyStore/SET_PAGE') {
        this.currentPage = this.currentPageV;
      }
    });

    this.$store.subscribe((mutation) => {
      if (mutation.type === 'VacancyStore/SET_TTRECORDS') {
        this.wordVacancy = this.totalRecords > 1 ? 'processos' : 'processo';
        this.wordOpen = this.totalRecords > 1 ? 'abertos' : 'aberto';
      }
    });
  },
  methods: {
    // setVacancyOwner(vacancy) {
    //   // let ownerName = this.vacancies.company[vacancy.relationships.company.data.id].attributes.name
    //   let showCompanyName = vacancy.attributes.promoteCompany

    //   if (showCompanyName == true){
    //     console.log(this.vacancies.customer[vacancy.relationships.customer.data])
    //     // ownerName = this.vacancies.customer[vacancy.relationships.customer.data.id].attributes.tradingName
    //     // console.log(ownerName)
    //   }
    //   return ownerName;
    // },
    updatePage(currentPage) {
      this.$store.dispatch('VacancyStore/loadVacancies', {
        from: 'searchbar',
        word: this.wordSearch,
        cityId: this.citySearch,
        level: this.levelSearch,
        contracting: this.contractingSearch,
        fitCandidate: this.fitCandidateSearch,
        page: currentPage,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#list-vacancy {
  table.table {
    thead {
      th {
        line-height: 1.1rem;
      }
    }
    tr {
      border-bottom: 1px solid #f1f2f3;

      td {
        font-size: 14px;

        a {
          color: #757575;
          line-height: 1.5;
        }
      }
    }
  }

  .pcd-logo {
    width: 18px;
    height: 18px;
  }

  .avatar {
    vertical-align: middle;
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }

  .vacancies-list-cards {
    .card {
      box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.11);
    }
  }

  .btn-apply,
  .btn-applied {
    min-width: 152px;
  }

  .not-result {
    background-color: #eeeeee;

    h3 {
      font-size: 6rem;
    }
    p {
      font-size: 1.1rem;
    }
  }
}

.popover {
  pointer-events: none !important;
  .popover-header {
    .size {
      height: 20px;
    }

    .representing-match {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 14px;

      img:last-child {
        margin-left: -14px;
      }
    }
  }
}
</style>
